const targetElementId = ".cbb-frequently-bought-plus-icon";

// AUCTION CODE
document.addEventListener('DOMContentLoaded', function() {
  setInterval(() => {
    if(document.querySelector('body.play-video')){
        document.querySelector('.webp-victory').classList.add('load'); 
    }
  }, 500);


  checkForAuctionChanges();
  const observer = new MutationObserver(checkForAuctionChanges);

  // Start observing the entire document subtree for changes
  observer.observe(document.body, {
      childList: true,  // Watch for changes in the child nodes
      subtree: true     // Watch for changes in the entire subtree of the body
  });

  renderVideo();


  localStorage.setItem('most-recent-auction', window.location.href);
});

function calculateTimeRemaining(){
  var endTime = document.querySelector(".tpa-product-widget .tpa-other-info__end_time .tpa-row__value").innerHTML

  let datePart;
  let timePart;

  let endMonthStr;
  let endDateStr;
  let endYearStr;

  let endHoursStr;
  let endMinutesStr;
  let endSecondsStr;

  let endDay;
  let endMonth;
  let endYear;
  let endHours;
  let endMinutes;
  let endSeconds;

  if(endTime.indexOf('PM') != -1 && endTime.indexOf('AM' != -1 )){
    // Parse the end date/time string in the format DD/MM/YYYY, HH:mm:ss
    [datePart, timePart] = endTime.split(', ');
    [endMonthStr, endDateStr, endYearStr] = datePart.split('/');
    [endHoursStr, endMinutesStr, endSecondsStr] = timePart.split(':');

    // Convert string parts to integers
    endDay = parseInt(endDateStr, 10);
    endMonth = parseInt(endMonthStr, 10) - 1; // Month is zero-indexed in JavaScript Date
    endYear = parseInt(endYearStr, 10);
    endHours = parseInt(endHoursStr, 10) + 12;
    endMinutes = parseInt(endMinutesStr, 10);
    endSeconds = parseInt(endSecondsStr, 10);

    datePart = endDateStr + '/' + endMonthStr + '/' + endYearStr;

  }else{
    // Parse the end date/time string in the format DD/MM/YYYY, HH:mm:ss
    [datePart, timePart] = endTime.split(', ');
    [endDateStr, endMonthStr, endYearStr] = datePart.split('/');
    [endHoursStr, endMinutesStr, endSecondsStr] = timePart.split(':');

    // Convert string parts to integers
    endDay = parseInt(endDateStr, 10);
    endMonth = parseInt(endMonthStr, 10) - 1; // Month is zero-indexed in JavaScript Date
    endYear = parseInt(endYearStr, 10);
    endHours = parseInt(endHoursStr, 10);
    endMinutes = parseInt(endMinutesStr, 10);
    endSeconds = parseInt(endSecondsStr, 10);
  }



 // Get the end date and time
 const endDate = new Date(endYear, endMonth, endDay, endHours, endMinutes, endSeconds);

 // Get the current date/time
 const now = new Date();

 // Calculate the difference in milliseconds
 const timeDifference = endDate - now;

 if (timeDifference <= 0) {
     // If end time has already passed
     // Auction Completed
     return 'Auction Closed';
 }

 // Convert milliseconds to days, hours, minutes, and seconds
 const millisecondsPerSecond = 1000;
 const millisecondsPerMinute = 60 * millisecondsPerSecond;
 const millisecondsPerHour = 60 * millisecondsPerMinute;
 const millisecondsPerDay = 24 * millisecondsPerHour;

 // Calculate remaining days
 const days = Math.floor(timeDifference / millisecondsPerDay);
 const remainingHours = timeDifference % millisecondsPerDay;

 // Calculate remaining hours
 const hours = Math.floor(remainingHours / millisecondsPerHour);
 const remainingMinutes = remainingHours % millisecondsPerHour;

 // Calculate remaining minutes
 const minutes = Math.floor(remainingMinutes / millisecondsPerMinute);
 const remainingSeconds = remainingMinutes % millisecondsPerMinute;

 // Calculate remaining seconds
 const seconds = Math.floor(remainingSeconds / millisecondsPerSecond);

 let returnString = "Initial String";

 if(days > 0){
  let dayText = ' day'
  if(days > 1){
    dayText += 's'
  }

  returnString = "Closing in " + days + dayText + ' (' + convertToDaythString(datePart) + ')';
 }

 if(days == 0 && hours > 0){
  let hourText = ' hour'
  if(hours != 1){
    hourText += 's'
  }
  let minuteText = ' minute'
  if(minutes != 1){
    minuteText += 's'
  }

  returnString = "Closing in " + hours + hourText + ' & ' + minutes + minuteText + ' (' + convertToGMTString(timePart) + ' GMT)';
 }

 if(days == 0 && hours == 0 && minutes >= 10){
  let minuteText = ' minute'
  if(minutes != 1){
    minuteText += 's'
  }

  returnString = "Closing in " + minutes + minuteText + ' (' + convertToGMTString(timePart)  + ' GMT)';

 }
 
 if(days == 0 && hours == 0 && minutes < 10){
  let minuteText = ' minute'
  if(minutes != 1){
    minuteText += 's'
  }

  let secondText = ' second'
  if(seconds != 1){
    secondText += 's'
  }

  returnString = "Closing in " + minutes + minuteText + ' & ' + seconds + secondText + ' (' + convertToGMTString(timePart)  + ' GMT)';
 }

 if(days == 0 && hours == 0 && minutes < 1){
  let secondText = ' second'
  if(seconds != 1){
    secondText += 's'
  }
  returnString = "Closing in " + seconds + secondText + ' (' + convertToGMTString(timePart)  + ' GMT)';
 }

 // Return correct closing string
 return returnString
}

function convertToDaythString(dateInput) {
  // Parse the date input string
  const [dayStr, monthStr, yearStr] = dateInput.split('/');

  // Convert string parts to integers
  const day = parseInt(dayStr, 10);
  const month = parseInt(monthStr, 10);
  const year = parseInt(yearStr, 10);

  // Determine the ordinal suffix for the day
  let daySuffix;
  if (day % 10 === 1 && day !== 11) {
      daySuffix = 'st';
  } else if (day % 10 === 2 && day !== 12) {
      daySuffix = 'nd';
  } else if (day % 10 === 3 && day !== 13) {
      daySuffix = 'rd';
  } else {
      daySuffix = 'th';
  }

  // Define month names (adjust as needed)
  const monthNames = [
      'January', 'February', 'March', 'April', 'May', 'June', 
      'July', 'August', 'September', 'October', 'November', 'December'
  ];

  // Get the month name based on the month number
  const monthName = monthNames[month - 1]; // Month is zero-indexed in JavaScript Date

  // Construct the formatted date string
  const formattedDate = `${day}${daySuffix} ${monthName} ${year}`;

  return formattedDate;
}


function convertToGMTString(timeInput){
  // Parse the input time string
  let [hoursStr, minutesStr] = timeInput.split(':');
  const hours = parseInt(hoursStr, 10);

  // remove 00 Minutes
  const minutes = parseInt(minutesStr, 10);
  minutesStr = ":" + minutesStr;
  if(minutes == 0){
    minutesStr = ""
  }

  // Determine if it's AM or PM
  const period = hours >= 12 ? 'PM' : 'AM';

  // Convert hours to 12-hour format
  const hours12 = hours % 12 || 12; // Convert 0 to 12 for 12-hour format

  // Construct the formatted time string
  const formattedTime = `${hours12}${minutesStr}${period}`;

  return formattedTime;
}

let auctionClosed = false;
let auctionFound = false;
let observed = false;
let auctionCompleted = false;
let auctionWon = false;

function checkForAuctionChanges() {

  console.log('checking for changes')

  if(!auctionFound){
    checkAuctionAvailability()
  }

  setTimeout(() => {
    console.log('Auction Closed: ', auctionClosed, "   Auction Found: ", auctionFound)
    if(!auctionClosed && !auctionFound){
      if(document.querySelector('.visually-hidden.auction-product.auction-closed')){

        auctionClosed = true;
  
        const closedContainer = document.createElement('div');
        closedContainer.classList.add('auction-closed-container__post');
  
        const pElement = document.createElement('p');
        var estimateValue = document.querySelector('#auction-data');
    
        if(estimateValue != null){
          pElement.textContent  = 'CLOSED ON: ' + estimateValue.getAttribute("data-auction-close-date");
        }else{
          pElement.textContent = 'This Auction has now closed.';
        }
  
        const buttonElement = document.createElement('button');
        buttonElement.textContent = 'FOR THE FUTURE';
        buttonElement.classList.add('auction-btn');
    
        buttonElement.addEventListener('click', function() {
          window.location.href = '/pages/newsletter';
        });
  
        closedContainer.appendChild(pElement);
        closedContainer.appendChild(buttonElement);
  
        document.querySelector('.product__content-header').appendChild(closedContainer);
        var pdpAuctionContainer = document.createElement('div');
        pdpAuctionContainer.classList.add('auction-pricing__container');

        var pdpPriceEstimate = document.createElement('div');
        pdpPriceEstimate.classList.add('price_estimate');

        var priceEstimateTitle = document.createElement('p');
        priceEstimateTitle.innerHTML = "Estimate: ";

        var estimateValue = document.querySelector('#auction-data');
        
        if(estimateValue != null){
          estimateValue = estimateValue.getAttribute("data-auction-estimate");
        }
        var priceEstimateValue = document.createElement('p');
        priceEstimateValue.innerHTML = estimateValue;
        
        pdpPriceEstimate.append(priceEstimateTitle);
        pdpPriceEstimate.append(priceEstimateValue);


        var pdpClosedPrice = document.createElement('div');
        pdpClosedPrice.classList.add('closing_price');

        var pdpClosedTitle = document.createElement('p');
        pdpClosedTitle.innerHTML = "CLOSING PRICE: ";

        var closingValue = document.querySelector('#auction-data');
        
        if(closingValue != null){
          closingValue = closingValue.getAttribute("data-auction-close-price");
        }
        var closingDateValue = document.createElement('p');
        closingDateValue.innerHTML = closingValue;
        
        pdpClosedPrice.append(pdpClosedTitle);
        pdpClosedPrice.append(closingDateValue);

        pdpAuctionContainer.append(pdpClosedPrice);
        pdpAuctionContainer.append(pdpPriceEstimate);


        let pdpDetails = document.querySelector('.product__content-header')
        pdpDetails.insertBefore(pdpAuctionContainer, pdpDetails.firstChild.nextSibling.nextSibling);

      }
    }else{
      console.log('This is either an inactive auction, or not an auction product. Auction Closed: ', auctionClosed, "   Auction Found: ", auctionFound)
    }
  }, 2000);
  
  
  // Select all div elements with the specified classes
  const elements = document.querySelectorAll('div.tpa-auction-message.warning.success');

  let auctionClosedPopup = document.querySelectorAll('.tpa-stopModal_header__title h1');

  let auctionWinIndicator = document.querySelectorAll('.auction-checkout-button')

  if(auctionClosedPopup.length > 0 && !auctionCompleted){


    const closedContainer = document.createElement('div');
    closedContainer.classList.add('auction-closed-container');

    const pElement = document.createElement('p');
    pElement.textContent = 'This Auction has now closed.';

    const secondPElement = document.createElement('p');
    secondPElement.textContent = 'Thank you for your participation.';

    const buttonElement = document.createElement('button');
    buttonElement.textContent = 'BACK TO THE LAND';
    buttonElement.classList.add('auction-btn');

    const arrowSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    arrowSvg.setAttribute("width", "10");
    arrowSvg.setAttribute("height", "10");
    arrowSvg.setAttribute("viewBox", "0 0 4 7");
    arrowSvg.innerHTML = '<path fill="#444" d="M0 3.5L4 0v7L0 3.5z"/>';
    
    buttonElement.appendChild(arrowSvg); // Append the SVG to the span

    buttonElement.addEventListener('click', function() {
      window.location.href = '/pages/auction-homepage';
    });

    document.querySelector('.tpa-stopModal_header__title h1').style.display = 'none';

    closedContainer.appendChild(pElement);
    closedContainer.appendChild(secondPElement);
    closedContainer.appendChild(buttonElement);
    document.querySelector('.tpa-stopModal_header__title').appendChild(closedContainer);

    document.querySelector('body').classList.add('play-video')

    auctionCompleted = true;
  }

  if(auctionWinIndicator.length > 0 && auctionCompleted && !auctionWon){
    const wonContainer = document.createElement('div');
    wonContainer.classList.add('auction-closed-container');

    const h1Element = document.createElement('h1');
    h1Element.textContent = 'THE WINNER TAKES IT ALL!';

    const anotherPElement = document.createElement('p');
    anotherPElement.textContent = 'Congratulations; you are the proud owner of the '+ document.querySelector('.product__title').innerHTML + '.';
    const finalPElement = document.createElement('p');
    finalPElement.textContent = 'E-mail about payment and delivery to follow.';

    const buttonElement = document.createElement('button');
    buttonElement.textContent = 'BACK TO THE LAND';
    buttonElement.classList.add('auction-btn');

    const arrowSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    arrowSvg.setAttribute("width", "10");
    arrowSvg.setAttribute("height", "10");
    arrowSvg.setAttribute("viewBox", "0 0 4 7");
    arrowSvg.innerHTML = '<path fill="#444" d="M0 3.5L4 0v7L0 3.5z"/>';
    
    buttonElement.appendChild(arrowSvg); // Append the SVG to the span

    buttonElement.addEventListener('click', function() {
      window.location.href = '/pages/auction-homepage';
    });
    

    document.querySelector('.tpa-stopModal_header__title h1').style.display = 'none';

    wonContainer.appendChild(h1Element);
    wonContainer.appendChild(anotherPElement);
    wonContainer.appendChild(finalPElement);
    wonContainer.appendChild(buttonElement);
    
    document.querySelector('.tpa-stopModal_header__title').appendChild(wonContainer);
    
    auctionWon = true;
  }

  // Check if any element matches the specified selector
  if (elements.length > 0 && !observed) {
      observed = true;
      // Log a message to the console
      document.querySelector('div.tpa-auction-message.warning.success .content').innerHTML = `
      <p>Congratulations; yours is our current highest bid. </p>
      <p>We'll notify you via email, should this change.</p>`

      let tracker = document.querySelector('.current_bid_tracker');
      let title = document.querySelector('.auction-title');

      tracker.classList.add('hide');
      title.classList.add('hide');

      document.querySelector('div.tpa-auction-message.warning.success .dismiss').addEventListener('click', function(){
        location.reload();
      });
  }
}

// for FBT APP... replace + signs with &'s
function checkElementExistence(elementId, callback) {
  // Define the interval check function
  const intervalId = setInterval(function () {
    // Check if the element exists
    const element = document.querySelector(elementId);
    if (element) {
      // If the element exists, call the callback function and clear the interval
      callback(element);
      clearInterval(intervalId);
    }
  }, 200); // You can adjust the interval time (in milliseconds) based on your requirements
}

// Callback function to be executed when the element is found
checkElementExistence(targetElementId, function () {
  const elements = document.querySelectorAll(targetElementId);
  const inputs = document.querySelectorAll(
    ".cbb-frequently-bought-selector-input"
  );

  elements.forEach((el) => {
    el.innerHTML = "&";
  });
  if (inputs.length > 0) {
    inputs.forEach((input) => {
      let customLabel = document.createElement("label");
      customLabel.classList.add("fbt-checkbox-label");
      wrap(input, customLabel);
    });
  }

  let ampersandIcon = document.querySelectorAll('.cbb-frequently-bought-plus-icon')
  let bundleOptions = document.querySelectorAll('.cbb-frequently-bought-product-image-link')
  let inputOptions = document.querySelectorAll('.cbb-frequently-bought-selector-list li')
  bundleOptions.forEach(element => {
    if(element.getAttribute('data-href').includes('bundle-product')){
      element.parentElement.style.display = 'none'
      ampersandIcon[ampersandIcon.length-1].style.display = 'none'
      inputOptions[inputOptions.length-1].style.display = 'none'

      
    }
  });


  function wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  }
});

function checkAuctionAvailability() {
  const auctionClosedElement = document.querySelector(".__stopBidding > div > div.tpa-endIn.tpa-text--heading-color");
  if (document.querySelector('.tpa-product-widget-wrapper') && !auctionClosedElement) {    
    auctionFound = true;
    document.querySelector('body').classList.add('auction-product');
    let auctionElement = document.querySelector('.tpa-product-widget-wrapper');

    //Hide all elements in auction app that aren't being used, or cannot be restyled to our needs
    auctionElement.classList.add('hide');
    auctionElement.classList.add('loaded');
    let productDetails =  document.querySelector('details:not(.exclude-this)');
    if(productDetails){
      productDetails.classList.add('hide');
    }

    // Create a button element
    var closeAuctionPopup = document.createElement("button");

    // Set the button's text content and classes
    closeAuctionPopup.innerHTML = `<svg viewBox="0 0 20 20" class="" focusable="false" aria-hidden="true"><path d="M11.414 10l4.293-4.293a.999.999 0 1 0-1.414-1.414L10 8.586 5.707 4.293a.999.999 0 1 0-1.414 1.414L8.586 10l-4.293 4.293a.999.999 0 1 0 1.414 1.414L10 11.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L11.414 10z" fill-rule="evenodd"></path></svg>`;
    closeAuctionPopup.classList.add('button');
    closeAuctionPopup.classList.add('close-button');
  
    // Add event listener to the button
    closeAuctionPopup.addEventListener("click", function() {
      event.preventDefault();
      auctionElement.classList.add('hide');
    });
  
    // Append the button to the body of the HTML document
    auctionElement.appendChild(closeAuctionPopup);

    var titleElement = document.createElement("p");
    var titleValue = document.querySelector('.product__form-wrapper').getAttribute("data-auction-title");
    
    titleElement.innerHTML = titleValue
    titleElement.classList.add('auction-title');
    auctionElement.insertBefore(titleElement, auctionElement.firstChild);

    // Create the Current Bid indicator
    var currentBidAmount = document.querySelector('.tpa-price').innerHTML.trim();
    var currentBidCount = document.querySelector('.tpa-other-info__number_bids .tpa-row__value').innerHTML;

    var currentBidElement = document.createElement('div');
    currentBidElement.classList.add('current_bid_tracker');

    var currentBidFirst = document.createElement('p');
    currentBidFirst.innerHTML = "CURRENT BID ("+ currentBidCount +" BIDS):";

    if(parseInt(currentBidCount) == 0){
      currentBidFirst.innerHTML = "RESERVE:"
    }

    var currentBidSecond = document.createElement('p');
    currentBidSecond.innerHTML = currentBidAmount;
    
    currentBidElement.append(currentBidFirst);
    currentBidElement.append(currentBidSecond);

    auctionElement.insertBefore(currentBidElement, auctionElement.firstChild.nextSibling);

    let yourBidElement = document.createElement('p');
    yourBidElement.textContent = "YOUR BID:";
    yourBidElement.classList.add('your-bid-title');
    auctionElement.insertBefore(yourBidElement, auctionElement.firstChild.nextSibling.nextSibling);
    

    auctionElement.insertBefore(currentBidElement, auctionElement.firstChild.nextSibling);
    

    var pdpAuctionContainer = document.createElement('div');
    pdpAuctionContainer.classList.add('auction-pricing__container');

    var pdpCurrentBid = currentBidElement.cloneNode(true);
    pdpCurrentBid.classList.add('current_bid');

    var pdpPriceEstimate = document.createElement('div');
    pdpPriceEstimate.classList.add('price_estimate');

    var priceEstimateTitle = document.createElement('p');
    priceEstimateTitle.innerHTML = "Estimate: ";

    var estimateValue = document.querySelector('#auction-data');
    
    if(estimateValue != null){
      estimateValue = estimateValue.getAttribute("data-auction-estimate");
    }
    var priceEstimateValue = document.createElement('p');
    priceEstimateValue.innerHTML = estimateValue;
    
    pdpPriceEstimate.append(priceEstimateTitle);
    pdpPriceEstimate.append(priceEstimateValue);

    pdpAuctionContainer.append(pdpCurrentBid);
    pdpAuctionContainer.append(pdpPriceEstimate);

    let pdpDetails = document.querySelector('.product__content-header')
    pdpDetails.insertBefore(pdpAuctionContainer, pdpDetails.firstChild.nextSibling.nextSibling);


    
    
    // Create a button element
    var bidPopupButton = document.createElement("button");

    // Check if the user is logged in
    var loggedIn = document.querySelector('.product__form-wrapper').getAttribute("data-logged-in");
    
    // Set the button's text content and classes
    if(loggedIn.includes('true')){
      bidPopupButton.textContent = "Place Bid";

      bidPopupButton.addEventListener("click", function() {
        auctionElement.classList.remove('hide');
      });
    }else{
      bidPopupButton.textContent = "Register to bid";
     
        bidPopupButton.addEventListener("click", function() {
          location.href='/pages/auction-login'
          //document.querySelector('.login-popup').classList.remove('hide');
        });
        // Call the createPopup function to create the popup when needed
        //createPopup();
    }
    bidPopupButton.classList.add('button','auction-button');
  
    // create container for PDP auction details

    var auctionContainer = document.createElement('div');
    auctionContainer.classList.add('auction__container');

    var countdownTimer = document.createElement('p');
    countdownTimer.innerHTML = calculateTimeRemaining();

    // Update countdown timer every second using setInterval
    const intervalId = setInterval(() => {
      countdownTimer.innerHTML = calculateTimeRemaining();

    }, 1000);
    auctionContainer.appendChild(countdownTimer);
  
    // Append the button to the body of the HTML document
    auctionContainer.appendChild(bidPopupButton);

    document.querySelector('.product__content-main').appendChild(auctionContainer);


    // Create the HOW IT WORKS element
    var howItWorksLink = document.createElement("a");
    
    // Set the href attribute
    howItWorksLink.setAttribute("href", "/pages/thames-at-auction-how-it-works");
    howItWorksLink.textContent = "How it works";
    howItWorksLink.classList.add('how-it-works');

    var clonedHowItWorksLink = howItWorksLink.cloneNode(true);
    // Append to auctionElement
    auctionElement.appendChild(howItWorksLink);
    // Append cloned element to .auction__container
    document.querySelector('.auction__container').appendChild(clonedHowItWorksLink);

  }
}


function renderVideo(){
    // Specify the URL of the webP image
    const videoTwoUrl = 'https://cdn.shopify.com/s/files/1/0256/6756/7713/files/T41-Draft-WebP-1920p-B.webp?v=1713888644';

    // Create a new <img> element
    const videoTwoElement = document.createElement('img');

    // Set the src attribute of the <img> element to the image URL
    videoTwoElement.src = videoTwoUrl;

    // Set the alt attribute (optional, for accessibility purposes)
    videoTwoElement.alt = 'WebP Victory Image';
    videoTwoElement.classList.add('webp-victory');
    videoTwoElement.classList.add('webp-victory-loop');
    
    // Append the <img> element to the body of the HTML document (or another container element)
    document.querySelector('body').appendChild(videoTwoElement);
    document.querySelector('body').classList.add('debug')
    document.querySelector('body').classList.remove('play-video');
  }
